import localStorageKey from "../../enumerations/localStorageKey";

export const setTomorrowCheck = (
  tomorrowCheckTime,
  checked,
  userInfo,
  targetName,
  noticeId = "",
) => {
  if (!checked) return;
  const tomorrowTime = new Date(new Date().toLocaleDateString()).getTime() + 86400000;
  let newTomorrowCheck = { ...tomorrowCheckTime };
  switch (targetName) {
    case "noticeReadTime":
      newTomorrowCheck[userInfo?.account_id] = {
        ...newTomorrowCheck[userInfo?.account_id],
        [targetName]: newTomorrowCheck[userInfo?.account_id]
          ? {
              ...newTomorrowCheck[userInfo?.account_id][targetName],
              [noticeId]: tomorrowTime,
            }
          : {
              [noticeId]: tomorrowTime,
            },
      };
      break;
    default:
      newTomorrowCheck[userInfo?.account_id] = {
        ...newTomorrowCheck[userInfo?.account_id],
        [targetName]: tomorrowTime,
      };
      break;
  }
  localStorage.setItem(localStorageKey.TOMORROW_CHECK_TIME, JSON.stringify(newTomorrowCheck));
};

export const tomorrowCheck = (
  tomorrowCheckTime,
  setVisible,
  userInfo,
  targetName,
  noticeId = "",
  setNextSorting,
) => {
  if (!tomorrowCheckTime) {
    setVisible(true);
    return;
  }
  const checkUser = tomorrowCheckTime[userInfo?.account_id];
  if (!checkUser) {
    setVisible(true);
    return;
  }
  let checkTime = tomorrowCheckTime[userInfo?.account_id][targetName];
  if (!checkTime) {
    setVisible(true);
    return;
  }
  if (targetName === "noticeReadTime") {
    const checkId = tomorrowCheckTime[userInfo?.account_id][targetName][noticeId];
    if (!checkId) {
      setVisible(true);
      return;
    } else {
      checkTime = tomorrowCheckTime[userInfo?.account_id][targetName][noticeId];
    }
  }
  const nowTime = new Date().getTime();
  if (nowTime - checkTime >= 0) {
    setVisible(true);
    return;
  }
  setNextSorting();
};

export const clickToScroll = (containerId, scrollTop) => {
  const scrollContainer = document.getElementById(containerId);
  scrollContainer.style.scrollBehavior = "smooth";
  scrollContainer.scrollTop = scrollTop;
  scrollContainer.style.scrollBehavior = "unset";
};

export const checkSearchParams = (params, setIsHaveInvitation, setIsHaveUID) => {
  const _invite_code = params.get("invite");
  const _puuid = params.get("puuid");
  if (_invite_code) {
    setIsHaveInvitation(true);
    window.localStorage.setItem(localStorageKey.INVITE_CODE, _invite_code);
  } else {
    setIsHaveInvitation(false);
  }
  if (_puuid) {
    setIsHaveUID(true);
    window.localStorage.setItem(localStorageKey.PUUID, _puuid);
  } else {
    setIsHaveUID(false);
  }
};
